import { COLORS } from '@lib/ui/theme';

import { ISnColorPickerColor } from './interfaces/color-picker-color.interface';

export const SN_COLOR_PICKER_COLORS: ISnColorPickerColor[] = [
  {
    key: 'red',
    className: 'bg-red-600',
    value: COLORS['red-600'],
    colors: [
      { key: '50', className: 'bg-red-50', value: COLORS['red-50'] },
      { key: '100', className: 'bg-red-100', value: COLORS['red-100'] },
      { key: '200', className: 'bg-red-200', value: COLORS['red-200'] },
      { key: '300', className: 'bg-red-300', value: COLORS['red-300'] },
      { key: '400', className: 'bg-red-400', value: COLORS['red-400'] },
      { key: '500', className: 'bg-red-500', value: COLORS['red-500'] },
      { key: '600', className: 'bg-red-600', value: COLORS['red-600'] },
      { key: '700', className: 'bg-red-700', value: COLORS['red-700'] },
      { key: '800', className: 'bg-red-800', value: COLORS['red-800'] },
      { key: '900', className: 'bg-red-900', value: COLORS['red-900'] },
    ],
  },

  {
    key: 'pink',
    className: 'bg-pink-600',
    value: COLORS['pink-600'],
    colors: [
      { key: '50', className: 'bg-pink-50', value: COLORS['pink-50'] },
      { key: '100', className: 'bg-pink-100', value: COLORS['pink-100'] },
      { key: '200', className: 'bg-pink-200', value: COLORS['pink-200'] },
      { key: '300', className: 'bg-pink-300', value: COLORS['pink-300'] },
      { key: '400', className: 'bg-pink-400', value: COLORS['pink-400'] },
      { key: '500', className: 'bg-pink-500', value: COLORS['pink-500'] },
      { key: '600', className: 'bg-pink-600', value: COLORS['pink-600'] },
      { key: '700', className: 'bg-pink-700', value: COLORS['pink-700'] },
      { key: '800', className: 'bg-pink-800', value: COLORS['pink-800'] },
      { key: '900', className: 'bg-pink-900', value: COLORS['pink-900'] },
    ],
  },

  {
    key: 'purple',
    className: 'bg-purple-600',
    value: COLORS['purple-600'],
    colors: [
      { key: '50', className: 'bg-purple-50', value: COLORS['purple-50'] },
      { key: '100', className: 'bg-purple-100', value: COLORS['purple-100'] },
      { key: '200', className: 'bg-purple-200', value: COLORS['purple-200'] },
      { key: '300', className: 'bg-purple-300', value: COLORS['purple-300'] },
      { key: '400', className: 'bg-purple-400', value: COLORS['purple-400'] },
      { key: '500', className: 'bg-purple-500', value: COLORS['purple-500'] },
      { key: '600', className: 'bg-purple-600', value: COLORS['purple-600'] },
      { key: '700', className: 'bg-purple-700', value: COLORS['purple-700'] },
      { key: '800', className: 'bg-purple-800', value: COLORS['purple-800'] },
      { key: '900', className: 'bg-purple-900', value: COLORS['purple-900'] },
    ],
  },

  {
    key: 'deep-purple',
    className: 'bg-deep-purple-600',
    value: COLORS['deep-purple-600'],
    colors: [
      { key: '50', className: 'bg-deep-purple-50', value: COLORS['deep-purple-50'] },
      { key: '100', className: 'bg-deep-purple-100', value: COLORS['deep-purple-100'] },
      { key: '200', className: 'bg-deep-purple-200', value: COLORS['deep-purple-200'] },
      { key: '300', className: 'bg-deep-purple-300', value: COLORS['deep-purple-300'] },
      { key: '400', className: 'bg-deep-purple-400', value: COLORS['deep-purple-400'] },
      { key: '500', className: 'bg-deep-purple-500', value: COLORS['deep-purple-500'] },
      { key: '600', className: 'bg-deep-purple-600', value: COLORS['deep-purple-600'] },
      { key: '700', className: 'bg-deep-purple-700', value: COLORS['deep-purple-700'] },
      { key: '800', className: 'bg-deep-purple-800', value: COLORS['deep-purple-800'] },
      { key: '900', className: 'bg-deep-purple-900', value: COLORS['deep-purple-900'] },
    ],
  },

  {
    key: 'indigo',
    className: 'bg-indigo-600',
    value: COLORS['indigo-600'],
    colors: [
      { key: '50', className: 'bg-indigo-50', value: COLORS['indigo-50'] },
      { key: '100', className: 'bg-indigo-100', value: COLORS['indigo-100'] },
      { key: '200', className: 'bg-indigo-200', value: COLORS['indigo-200'] },
      { key: '300', className: 'bg-indigo-300', value: COLORS['indigo-300'] },
      { key: '400', className: 'bg-indigo-400', value: COLORS['indigo-400'] },
      { key: '500', className: 'bg-indigo-500', value: COLORS['indigo-500'] },
      { key: '600', className: 'bg-indigo-600', value: COLORS['indigo-600'] },
      { key: '700', className: 'bg-indigo-700', value: COLORS['indigo-700'] },
      { key: '800', className: 'bg-indigo-800', value: COLORS['indigo-800'] },
      { key: '900', className: 'bg-indigo-900', value: COLORS['indigo-900'] },
    ],
  },

  {
    key: 'blue',
    className: 'bg-blue-600',
    value: COLORS['blue-600'],
    colors: [
      { key: '50', className: 'bg-blue-50', value: COLORS['blue-50'] },
      { key: '100', className: 'bg-blue-100', value: COLORS['blue-100'] },
      { key: '200', className: 'bg-blue-200', value: COLORS['blue-200'] },
      { key: '300', className: 'bg-blue-300', value: COLORS['blue-300'] },
      { key: '400', className: 'bg-blue-400', value: COLORS['blue-400'] },
      { key: '500', className: 'bg-blue-500', value: COLORS['blue-500'] },
      { key: '600', className: 'bg-blue-600', value: COLORS['blue-600'] },
      { key: '700', className: 'bg-blue-700', value: COLORS['blue-700'] },
      { key: '800', className: 'bg-blue-800', value: COLORS['blue-800'] },
      { key: '900', className: 'bg-blue-900', value: COLORS['blue-900'] },
    ],
  },

  {
    key: 'light-blue',
    className: 'bg-light-blue-600',
    value: COLORS['light-blue-600'],
    colors: [
      { key: '50', className: 'bg-light-blue-50', value: COLORS['light-blue-50'] },
      { key: '100', className: 'bg-light-blue-100', value: COLORS['light-blue-100'] },
      { key: '200', className: 'bg-light-blue-200', value: COLORS['light-blue-200'] },
      { key: '300', className: 'bg-light-blue-300', value: COLORS['light-blue-300'] },
      { key: '400', className: 'bg-light-blue-400', value: COLORS['light-blue-400'] },
      { key: '500', className: 'bg-light-blue-500', value: COLORS['light-blue-500'] },
      { key: '600', className: 'bg-light-blue-600', value: COLORS['light-blue-600'] },
      { key: '700', className: 'bg-light-blue-700', value: COLORS['light-blue-700'] },
      { key: '800', className: 'bg-light-blue-800', value: COLORS['light-blue-800'] },
      { key: '900', className: 'bg-light-blue-900', value: COLORS['light-blue-900'] },
    ],
  },

  {
    key: 'cyan',
    className: 'bg-cyan-600',
    value: COLORS['cyan-600'],
    colors: [
      { key: '50', className: 'bg-cyan-50', value: COLORS['cyan-50'] },
      { key: '100', className: 'bg-cyan-100', value: COLORS['cyan-100'] },
      { key: '200', className: 'bg-cyan-200', value: COLORS['cyan-200'] },
      { key: '300', className: 'bg-cyan-300', value: COLORS['cyan-300'] },
      { key: '400', className: 'bg-cyan-400', value: COLORS['cyan-400'] },
      { key: '500', className: 'bg-cyan-500', value: COLORS['cyan-500'] },
      { key: '600', className: 'bg-cyan-600', value: COLORS['cyan-600'] },
      { key: '700', className: 'bg-cyan-700', value: COLORS['cyan-700'] },
      { key: '800', className: 'bg-cyan-800', value: COLORS['cyan-800'] },
      { key: '900', className: 'bg-cyan-900', value: COLORS['cyan-900'] },
    ],
  },

  {
    key: 'teal',
    className: 'bg-teal-600',
    value: COLORS['teal-600'],
    colors: [
      { key: '50', className: 'bg-teal-50', value: COLORS['teal-50'] },
      { key: '100', className: 'bg-teal-100', value: COLORS['teal-100'] },
      { key: '200', className: 'bg-teal-200', value: COLORS['teal-200'] },
      { key: '300', className: 'bg-teal-300', value: COLORS['teal-300'] },
      { key: '400', className: 'bg-teal-400', value: COLORS['teal-400'] },
      { key: '500', className: 'bg-teal-500', value: COLORS['teal-500'] },
      { key: '600', className: 'bg-teal-600', value: COLORS['teal-600'] },
      { key: '700', className: 'bg-teal-700', value: COLORS['teal-700'] },
      { key: '800', className: 'bg-teal-800', value: COLORS['teal-800'] },
      { key: '900', className: 'bg-teal-900', value: COLORS['teal-900'] },
    ],
  },

  {
    key: 'green',
    className: 'bg-green-600',
    value: COLORS['green-600'],
    colors: [
      { key: '50', className: 'bg-green-50', value: COLORS['green-50'] },
      { key: '100', className: 'bg-green-100', value: COLORS['green-100'] },
      { key: '200', className: 'bg-green-200', value: COLORS['green-200'] },
      { key: '300', className: 'bg-green-300', value: COLORS['green-300'] },
      { key: '400', className: 'bg-green-400', value: COLORS['green-400'] },
      { key: '500', className: 'bg-green-500', value: COLORS['green-500'] },
      { key: '600', className: 'bg-green-600', value: COLORS['green-600'] },
      { key: '700', className: 'bg-green-700', value: COLORS['green-700'] },
      { key: '800', className: 'bg-green-800', value: COLORS['green-800'] },
      { key: '900', className: 'bg-green-900', value: COLORS['green-900'] },
    ],
  },

  {
    key: 'light-green',
    className: 'bg-light-green-600',
    value: COLORS['light-green-600'],
    colors: [
      { key: '50', className: 'bg-light-green-50', value: COLORS['light-green-50'] },
      { key: '100', className: 'bg-light-green-100', value: COLORS['light-green-100'] },
      { key: '200', className: 'bg-light-green-200', value: COLORS['light-green-200'] },
      { key: '300', className: 'bg-light-green-300', value: COLORS['light-green-300'] },
      { key: '400', className: 'bg-light-green-400', value: COLORS['light-green-400'] },
      { key: '500', className: 'bg-light-green-500', value: COLORS['light-green-500'] },
      { key: '600', className: 'bg-light-green-600', value: COLORS['light-green-600'] },
      { key: '700', className: 'bg-light-green-700', value: COLORS['light-green-700'] },
      { key: '800', className: 'bg-light-green-800', value: COLORS['light-green-800'] },
      { key: '900', className: 'bg-light-green-900', value: COLORS['light-green-900'] },
    ],
  },

  {
    key: 'lime',
    className: 'bg-lime-600',
    value: COLORS['lime-600'],
    colors: [
      { key: '50', className: 'bg-lime-50', value: COLORS['lime-50'] },
      { key: '100', className: 'bg-lime-100', value: COLORS['lime-100'] },
      { key: '200', className: 'bg-lime-200', value: COLORS['lime-200'] },
      { key: '300', className: 'bg-lime-300', value: COLORS['lime-300'] },
      { key: '400', className: 'bg-lime-400', value: COLORS['lime-400'] },
      { key: '500', className: 'bg-lime-500', value: COLORS['lime-500'] },
      { key: '600', className: 'bg-lime-600', value: COLORS['lime-600'] },
      { key: '700', className: 'bg-lime-700', value: COLORS['lime-700'] },
      { key: '800', className: 'bg-lime-800', value: COLORS['lime-800'] },
      { key: '900', className: 'bg-lime-900', value: COLORS['lime-900'] },
    ],
  },

  {
    key: 'yellow',
    className: 'bg-yellow-600',
    value: COLORS['yellow-600'],
    colors: [
      { key: '50', className: 'bg-yellow-50', value: COLORS['yellow-50'] },
      { key: '100', className: 'bg-yellow-100', value: COLORS['yellow-100'] },
      { key: '200', className: 'bg-yellow-200', value: COLORS['yellow-200'] },
      { key: '300', className: 'bg-yellow-300', value: COLORS['yellow-300'] },
      { key: '400', className: 'bg-yellow-400', value: COLORS['yellow-400'] },
      { key: '500', className: 'bg-yellow-500', value: COLORS['yellow-500'] },
      { key: '600', className: 'bg-yellow-600', value: COLORS['yellow-600'] },
      { key: '700', className: 'bg-yellow-700', value: COLORS['yellow-700'] },
      { key: '800', className: 'bg-yellow-800', value: COLORS['yellow-800'] },
      { key: '900', className: 'bg-yellow-900', value: COLORS['yellow-900'] },
    ],
  },

  {
    key: 'amber',
    className: 'bg-amber-600',
    value: COLORS['amber-600'],
    colors: [
      { key: '50', className: 'bg-amber-50', value: COLORS['amber-50'] },
      { key: '100', className: 'bg-amber-100', value: COLORS['amber-100'] },
      { key: '200', className: 'bg-amber-200', value: COLORS['amber-200'] },
      { key: '300', className: 'bg-amber-300', value: COLORS['amber-300'] },
      { key: '400', className: 'bg-amber-400', value: COLORS['amber-400'] },
      { key: '500', className: 'bg-amber-500', value: COLORS['amber-500'] },
      { key: '600', className: 'bg-amber-600', value: COLORS['amber-600'] },
      { key: '700', className: 'bg-amber-700', value: COLORS['amber-700'] },
      { key: '800', className: 'bg-amber-800', value: COLORS['amber-800'] },
      { key: '900', className: 'bg-amber-900', value: COLORS['amber-900'] },
    ],
  },

  {
    key: 'orange',
    className: 'bg-orange-600',
    value: COLORS['orange-600'],
    colors: [
      { key: '50', className: 'bg-orange-50', value: COLORS['orange-50'] },
      { key: '100', className: 'bg-orange-100', value: COLORS['orange-100'] },
      { key: '200', className: 'bg-orange-200', value: COLORS['orange-200'] },
      { key: '300', className: 'bg-orange-300', value: COLORS['orange-300'] },
      { key: '400', className: 'bg-orange-400', value: COLORS['orange-400'] },
      { key: '500', className: 'bg-orange-500', value: COLORS['orange-500'] },
      { key: '600', className: 'bg-orange-600', value: COLORS['orange-600'] },
      { key: '700', className: 'bg-orange-700', value: COLORS['orange-700'] },
      { key: '800', className: 'bg-orange-800', value: COLORS['orange-800'] },
      { key: '900', className: 'bg-orange-900', value: COLORS['orange-900'] },
    ],
  },

  {
    key: 'deep-orange',
    className: 'bg-deep-orange-600',
    value: COLORS['deep-orange-600'],
    colors: [
      { key: '50', className: 'bg-deep-orange-50', value: COLORS['deep-orange-50'] },
      { key: '100', className: 'bg-deep-orange-100', value: COLORS['deep-orange-100'] },
      { key: '200', className: 'bg-deep-orange-200', value: COLORS['deep-orange-200'] },
      { key: '300', className: 'bg-deep-orange-300', value: COLORS['deep-orange-300'] },
      { key: '400', className: 'bg-deep-orange-400', value: COLORS['deep-orange-400'] },
      { key: '500', className: 'bg-deep-orange-500', value: COLORS['deep-orange-500'] },
      { key: '600', className: 'bg-deep-orange-600', value: COLORS['deep-orange-600'] },
      { key: '700', className: 'bg-deep-orange-700', value: COLORS['deep-orange-700'] },
      { key: '800', className: 'bg-deep-orange-800', value: COLORS['deep-orange-800'] },
      { key: '900', className: 'bg-deep-orange-900', value: COLORS['deep-orange-900'] },
    ],
  },

  {
    key: 'brown',
    className: 'bg-brown-600',
    value: COLORS['brown-600'],
    colors: [
      { key: '50', className: 'bg-brown-50', value: COLORS['brown-50'] },
      { key: '100', className: 'bg-brown-100', value: COLORS['brown-100'] },
      { key: '200', className: 'bg-brown-200', value: COLORS['brown-200'] },
      { key: '300', className: 'bg-brown-300', value: COLORS['brown-300'] },
      { key: '400', className: 'bg-brown-400', value: COLORS['brown-400'] },
      { key: '500', className: 'bg-brown-500', value: COLORS['brown-500'] },
      { key: '600', className: 'bg-brown-600', value: COLORS['brown-600'] },
      { key: '700', className: 'bg-brown-700', value: COLORS['brown-700'] },
      { key: '800', className: 'bg-brown-800', value: COLORS['brown-800'] },
      { key: '900', className: 'bg-brown-900', value: COLORS['brown-900'] },
    ],
  },

  {
    key: 'grey',
    className: 'bg-grey-600',
    value: COLORS['grey-600'],
    colors: [
      { key: '0', className: 'bg-grey-0', value: COLORS['grey-0'] },
      { key: '50', className: 'bg-grey-50', value: COLORS['grey-50'] },
      { key: '100', className: 'bg-grey-100', value: COLORS['grey-100'] },
      { key: '200', className: 'bg-grey-200', value: COLORS['grey-200'] },
      { key: '300', className: 'bg-grey-300', value: COLORS['grey-300'] },
      { key: '400', className: 'bg-grey-400', value: COLORS['grey-400'] },
      { key: '500', className: 'bg-grey-500', value: COLORS['grey-500'] },
      { key: '600', className: 'bg-grey-600', value: COLORS['grey-600'] },
      { key: '700', className: 'bg-grey-700', value: COLORS['grey-700'] },
      { key: '800', className: 'bg-grey-800', value: COLORS['grey-800'] },
      { key: '900', className: 'bg-grey-900', value: COLORS['grey-900'] },
    ],
  },

  {
    key: 'blue-grey',
    className: 'bg-blue-grey-600',
    value: COLORS['blue-grey-600'],
    colors: [
      { key: '50', className: 'bg-blue-grey-50', value: COLORS['blue-grey-50'] },
      { key: '100', className: 'bg-blue-grey-100', value: COLORS['blue-grey-100'] },
      { key: '200', className: 'bg-blue-grey-200', value: COLORS['blue-grey-200'] },
      { key: '300', className: 'bg-blue-grey-300', value: COLORS['blue-grey-300'] },
      { key: '400', className: 'bg-blue-grey-400', value: COLORS['blue-grey-400'] },
      { key: '500', className: 'bg-blue-grey-500', value: COLORS['blue-grey-500'] },
      { key: '600', className: 'bg-blue-grey-600', value: COLORS['blue-grey-600'] },
      { key: '700', className: 'bg-blue-grey-700', value: COLORS['blue-grey-700'] },
      { key: '800', className: 'bg-blue-grey-800', value: COLORS['blue-grey-800'] },
      { key: '900', className: 'bg-blue-grey-900', value: COLORS['blue-grey-900'] },
    ],
  },
];
